import React from "react";
import {
  Animated,
  ScrollView,
  ScrollViewProps,
  StyleSheet,
} from "react-native";

const AnimatedScrollView = (
  props: {
    onScroll?: Function;
    children;
    style?;
    animated?;
    reference?;
  } & ScrollViewProps
) => {
  const { children, style, animated = false, onScroll, reference } = props;
  const extraProps = {};
  if (animated) {
    extraProps["onScroll"] = Animated.event(
      [
        {
          nativeEvent: {
            contentOffset: {
              y: reference,
            },
          },
        },
      ],
      { useNativeDriver: false }
    );
  } else if (onScroll) {
    extraProps["onScroll"] = onScroll;
  }
  return (
    <ScrollView
      keyboardShouldPersistTaps="always"
      bounces={false}
      contentContainerStyle={styles.contentContainerStyle}
      style={style}
      showsVerticalScrollIndicator={false}
      {...props}
      {...extraProps}
    >
      {children}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  contentContainerStyle: {
    paddingBottom: 36,
  },
});

export default AnimatedScrollView;
